module.exports = __webpack_public_path__ + "img/angststoerungen1_3000.dddf88ff.png";